// extracted by mini-css-extract-plugin
module.exports = {"createGroupButtonContainer":"FHIRAccessManagement-tab_createGroupButtonContainer_1d4jC"};